import '@babel/polyfill'
import React from 'react'
import { render } from 'react-dom'
import Pocasi from '../layouts/pocasi'
import RavenWrapper from '../components/utils/Raven'

const {
  sentry,
  version,
  environment
} = __INITIAL_STATE__.config
const container = document.getElementById('homepage')

render(
  <RavenWrapper config={sentry} version={version} environment={environment}>
    <Pocasi widgets={__INITIAL_STATE__} layout='pocasi' clientSide/>
  </RavenWrapper>,
  container
)
